<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="400" persistent>
    <v-card>
      <v-card-title class="headline">Add New Rep</v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent>
          <v-text-field label="Territory ID" v-model="form.territoryId"
            :rules="[v => !!v || 'Required']" required></v-text-field>
          <v-text-field label="Rep Name" v-model="form.repName"
            :rules="[v => !!v || 'Required']" required></v-text-field>
          <v-select label="Color" :items="colorItems" v-model="form.color"
            :rules="[v => !!v || 'Required']" required>
            <template slot="selection" slot-scope="data">
              <span class="zac-color-swatch" :style="{ background: data.item.value }"></span>
              <span class="ml-2 caption">{{ data.item.value }}</span>
            </template>
            <template slot="item" slot-scope="data">
              <span class="zac-color-swatch" :style="{ background: data.item.value }"></span>
              <span class="ml-2 caption">{{ data.item.value }}</span>
            </template>
          </v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    colors: { type: Array, default: () => [] },
    defaultColor: { type: String, default: '' },
  },
  data () {
    return {
      form: { territoryId: '', repName: '', color: '' },
    }
  },
  computed: {
    colorItems () { return this.colors.map(c => ({ text: c, value: c })) },
  },
  watch: {
    value (open) {
      if (open) {
        this.form = {
          territoryId: '',
          repName: '',
          color: this.defaultColor || (this.colors[0] || ''),
        }
        this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
      }
    },
  },
  methods: {
    // Save no longer relies on a v-model'd formValid flag — that flag stays
    // false until each field is touched, which made Save look broken when
    // users typed values and immediately clicked Save. Now we always allow
    // the click and let validate() decide whether to proceed or show errors.
    save () {
      if (this.$refs.form && !this.$refs.form.validate()) return
      this.$emit('save', { ...this.form })
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
.zac-color-swatch { display: inline-block; width: 16px; height: 16px; border-radius: 2px; vertical-align: middle; border: 1px solid #ccc; }
</style>
